import { Redirect, navigate } from '@reach/router';
import { getDelegatedOrCurrentCompanyId } from 'app/dux/session/selectors';
import { AppState } from 'app/store/reducers';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { swapPathCompanyId } from 'routes/paths';


const mapStateToProps = (state: AppState) => ({
    companyId: getDelegatedOrCurrentCompanyId(state),
});

interface Props {
    companyId: string;
}


class RedirectToCompany extends Component<Props> {
    render() {
        const { companyId } = this.props;
        const path = swapPathCompanyId(location.pathname, companyId);
        navigate(path);
        return <Redirect to={path} noThrow />;
    }
}

const decorated = connect(mapStateToProps)(RedirectToCompany);
export { decorated as RootRedirectToCompany };
